import { render, staticRenderFns } from "./confirm-delete-category.vue?vue&type=template&id=2850c1d9&scoped=true"
import script from "./confirm-delete-category.vue?vue&type=script&lang=js"
export * from "./confirm-delete-category.vue?vue&type=script&lang=js"
import style0 from "./confirm-delete-category.vue?vue&type=style&index=0&id=2850c1d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2850c1d9",
  null
  
)

export default component.exports